var chunkMapping = {
	"1505": [
		1505
	],
	"2390": [
		2390
	],
	"2483": [
		2483
	],
	"2501": [
		2501
	],
	"2847": [
		2847
	],
	"3345": [
		3345
	],
	"3528": [
		3528
	],
	"4204": [
		4204
	],
	"4553": [
		4553
	],
	"4873": [
		4873
	],
	"5499": [
		5499
	],
	"6238": [
		6238
	],
	"6688": [
		6688
	],
	"7643": [
		222,
		3646,
		5106,
		5407
	],
	"8181": [
		599,
		6234
	],
	"8225": [
		8225
	],
	"8873": [
		3013
	]
};
var idToExternalAndNameMapping = {
	"222": [
		"default",
		"./SupportGuideOverlay",
		3957
	],
	"599": [
		"default",
		"./Aside",
		657
	],
	"1505": [
		"default",
		"./Catalog",
		609
	],
	"2390": [
		"default",
		"./KitchenDetail",
		8229
	],
	"2483": [
		"default",
		"./Header",
		657
	],
	"2501": [
		"default",
		"./CartToast",
		5930
	],
	"2847": [
		"default",
		"./SearchView",
		6537
	],
	"3013": [
		"default",
		"./PIPView",
		8229
	],
	"3345": [
		"default",
		"./ScrollToTop",
		5168
	],
	"3528": [
		"default",
		"./CopilotFrame",
		5930
	],
	"3646": [
		"default",
		"./CustomerProvider",
		5483
	],
	"4204": [
		"default",
		"./Browse",
		609
	],
	"4553": [
		"default",
		"./CustomerOrders",
		5930
	],
	"4873": [
		"default",
		"./CombinationView",
		8229
	],
	"5106": [
		"default",
		"./CartStoreProvider",
		5930
	],
	"5407": [
		"default",
		"./ServiceProvider",
		5930
	],
	"5499": [
		"default",
		"./languageService",
		5168
	],
	"6234": [
		"default",
		"./layoutSizeHelper",
		5168
	],
	"6238": [
		"default",
		"./colorHelper",
		5168
	],
	"6688": [
		"default",
		"./Admin",
		8389
	],
	"8225": [
		"default",
		"./CartView",
		5930
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}